<template>
  <v-app>
    <v-container>
      <v-row no-gutters>
        <!-- Sidebar -->
        <v-col cols="12" sm="3" md="2" class="sidebar pa-0" v-if="!$vuetify.breakpoint.mobile">
          <v-card flat class="rounded-xl mt-6 ml-6">
            <v-sheet color="indigo darken-4" class="pa-3 white--text rounded-t-xl">
              {{ $t('bookType') }}
            </v-sheet>

            <v-list dense>
              <v-list-item
                  v-for="(item, i) in menuItems"
                  :key="i"
                  @click="fetchBook(item)"
                  link
                  class="py-1"
              >
                <v-list-item-content
                    :style="{color: params.category===item ? 'white' : '', backgroundColor: params.category === item ? 'gray' : ''}">
                  <v-list-item-title>{{ $t(item) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <!-- Main Content -->
        <v-col cols="12" sm="9" md="10" class="pa-6">
          <h2 class="text-h5 mb-6 font-weight-bold">{{ $t('e-library') }}</h2>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
                type="text"
                v-model="params.search"
                :placeholder="$t('searchHere')"
                persistent-hint
                @keyup="fetchBook()"
                :dense="dense"
                filled
            ></v-text-field>
          </v-col>
          <v-row>
            <v-col
                v-for="book in books"
                :key="book._id"
                cols="12"
                sm="6"
                md="3"
                class="mb-8"
            >
              <v-card flat outlined>
                <a :href="book.fileUrl" target="_blank" class="href">
                  <v-img contain :src="book.imgUrl" height="250px" class="rounded-t"></v-img>
                </a>
                <!--                <iframe
                                    :src="book.fileUrl"
                                    width="100%"
                                    height="600px"
                                    style="border: none;"
                                ></iframe>-->
                <v-card-text class="pa-3">
                  <v-chip small outlined color="grey" class="mb-1">{{ book.title }}</v-chip>
                  <div class="text-subtitle-2 font-weight-medium mt-1">{{ book.titleEn }}</div>
                  <div class="text-subtitle-2 font-weight-medium mt-1">{{ book.body }}</div>
                  <div class="grey--text text-caption">{{ book.author }}</div>
                  <a :href="book.fileUrl" target="_blank" class="href">
                    <div class="grey--text text-caption">Download</div>
                  </a>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {Constants} from "@/libs/constant";
import axios from "axios";

export default {
  data() {
    return {
      menuItems: [
        'electricity',
        'electronic',
        'informationTechnology',
        'agriculture',
        'bankAndFinance',
        'mechanic',
        'foreignLanguage',
        'other',
      ],
      params: {
        search: "",
        skip: 0,
        limit: 100,
        category: "",
      },
      books: []
    }
  },
  methods: {
    fetchBook(category) {
      let vm = this;
      let url = Constants.baseURL + Constants.api.getBook;
      vm.params.category = category || "";
      return new Promise((resolve, reject) => {
        axios.get(url, {params: vm.params, headers: {token: Constants.token}}).then(
            res => {

              if (res.data.code === 201) {
                resolve(res.data.data);
                vm.books = res.data.data.content;
                console.log(vm.books);
              }
            },
            error => {
              reject(error);
            }
        );
      });
    }
  },
  created() {
    this.fetchBook();
  },
}
</script>

<style>
.sidebar {
  background-color: white;
  border-right: 1px solid #e0e0e0;
  height: 100vh;
  position: sticky;
  top: 0;
}

.v-list-item:hover {
  background-color: #f5f5f5;
}

.v-list-item-title {
  font-size: 14px;
  color: #333;
}
</style>
